<!--
 * @Description: (弹框)商户编辑表单组件
 * @Author: gaohc
 * @Date: 2022-10-13 16:43:52
-->
<template>
  <div class="body">
    <el-drawer title="商户审核" :before-close="handleClose" :visible.sync="visible" direction="rtl"
      size="1000px" @open="initData" ref="drawer" withHeader :wrapperClosable="true">
      <div class="review-result-wrap" v-if="mchFormData && mchFormData.review">
        <review-history :review="mchFormData.review"></review-history>
      </div>
      <common-mch-form ref="mchForm" @close-drawer="handleCloseDrawer" />
    </el-drawer>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import commonMchForm from "../../../mchmng/components/CommonMchForm.vue";
import ReviewHistory from "../ReviewHistory.vue";
import mchStore from "../../../mchmng/components/MchStore.js";

export default {
  name: "MchEditForm",
  props: ["visible", "mchId"],
  components: {
    "common-mch-form": commonMchForm,
    "review-history": ReviewHistory
  },
  mchStore,

  data() {
    return {
      mchFormData: {},
    };
  },

  methods: {
    async initData() {
      mchStore.commit("changeMode", "edit");
      this.mchFormData = await this.queryData();
      this.mchFormData.review["reviewHistoryList"] = this.mchFormData.reviewHistoryList;
      mchStore.commit("changeMchFormData", this.mchFormData);
      if (this.mchFormData.bankAccount.bankNameDetail == "") return;
      let cityList = await this.requsetCityList(this.mchFormData.bankAccount.bankProvinceCode);
      mchStore.commit("changeSrcCityList", cityList);
      let branchesList = await this.requsetBranchesList(this.mchFormData.bankAccount.bankCityCode, this.mchFormData.bankAccount.bankNameCode);
      mchStore.commit("changeSrcBranchesList", branchesList);
    },

    queryData() {
      return new Promise((resolve) => {
        let params = {id: this.mchId};
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(params,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_MERCHANT_DO4UPDATE,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          resolve(result.data);
        })
      });
    },

    //请求市数据
		requsetCityList(bankProvinceCode) {
      return new Promise((resolve) => {
        let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_LIST_CITIES, bankProvinceCode);
				this.appAxios("GET", url).then(resultCity => {
					if (resultCity != null) {
						resolve(resultCity.data);
					}
				})
      })
    },

    //请求支行数据
		requsetBranchesList(cityCode, bankNameCode) {
      return new Promise((resolve) => {
        let params = {
          bankAliasCode: bankNameCode,
          cityCode: cityCode
        };
        this.appAxios("GET", Constant.URL_GET_LIST_BRANCHES, params).then(result => {
					if (result != null) {
						resolve(result.data);
					}
				})
      })
    },

    //关闭申请收付通商户表单抽屉
    handleClose() {
      this.clearData();
      this.$emit("close-drawer", false);
    },

    handleCloseDrawer(refresh) {
      if (refresh) {
        this.handleSubmitFormData();
      } else {
        this.clearData();
        this.$emit("close-drawer", refresh);
      }
    },

    handleSubmitFormData() {
      let fileMap = new Map();
      if (mchStore.state.bizLicenseFile && mchStore.state.bizLicenseFile.raw) {
        fileMap.set("bizLicenseFile", mchStore.state.bizLicenseFile.raw);
      }

      if (mchStore.state.idCardImg1File && mchStore.state.idCardImg1File.raw) {
        fileMap.set("idCardImg1File", mchStore.state.idCardImg1File.raw);
      }

      if (mchStore.state.idCardImg2File && mchStore.state.idCardImg2File.raw) {
        fileMap.set("idCardImg2File", mchStore.state.idCardImg2File.raw);
      }
      let param = {'name': 'merchantVO', 'value': {...mchStore.state.commonMchForm}};
      let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				param, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        url: Constant.URL_UPDATE_MERCHANT,
        method: 'PUT',
        header: header,
        param: esParams,
        files: fileMap,
        contentType: this.commonConst.CNTYPE_JSON
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
		
        this.clearData();
        this.$emit("close-drawer", true);
      });
    },

    clearData() {
      this.$refs.mchForm.$refs.commonMchForm.clearValidate();
      this.mchFormData = {};
      mchStore.commit("changeCommonMchForm", { bankAccount: {}, merchant: {} });
      mchStore.commit("changeBizLicenseFile", null);
      mchStore.commit("changeIdCardImg1File", null);
      mchStore.commit("changeIdCardImg2Path", null);
      mchStore.commit('changeSrcProvinceList', []);
      mchStore.commit('changeSrcCityList', []);
      mchStore.commit('changeSrcBranchesList', []);
    },
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.review-result-wrap {
  padding: 0 60px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/mchReviewList/MchEditForm.vue